'use client';

import { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface ChartData {
  month: string;
  deals: number;
  roi: number;
}

const PerformanceChart = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const chartData: ChartData[] = [
    { month: 'Jan', deals: 12, roi: 18.5 },
    { month: 'Feb', deals: 15, roi: 22.3 },
    { month: 'Mar', deals: 18, roi: 25.7 },
    { month: 'Apr', deals: 14, roi: 19.8 },
    { month: 'May', deals: 20, roi: 28.4 },
    { month: 'Jun', deals: 22, roi: 31.2 },
  ];

  if (!isHydrated) {
    return (
      <div className="bg-card rounded-lg shadow-card p-6 border border-border">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/3 mb-4"></div>
          <div className="h-64 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-card p-6 border border-border">
      <h3 className="text-lg font-heading font-bold text-foreground mb-6">6-Month Performance Overview</h3>
      <div className="w-full h-80" aria-label="Six month deal performance bar chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(27, 54, 93, 0.1)" />
            <XAxis dataKey="month" stroke="#64748B" style={{ fontSize: '12px' }} />
            <YAxis yAxisId="left" stroke="#1B365D" style={{ fontSize: '12px' }} />
            <YAxis yAxisId="right" orientation="right" stroke="#00A86B" style={{ fontSize: '12px' }} />
            <Tooltip
              contentStyle={{
                backgroundColor: '#FFFFFF',
                border: '1px solid rgba(27, 54, 93, 0.12)',
                borderRadius: '8px',
                fontSize: '12px',
              }}
            />
            <Legend wrapperStyle={{ fontSize: '12px' }} />
            <Bar yAxisId="left" dataKey="deals" fill="#1B365D" name="Deals Completed" radius={[8, 8, 0, 0]} />
            <Bar yAxisId="right" dataKey="roi" fill="#00A86B" name="Avg ROI %" radius={[8, 8, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceChart;